/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationBackgroundImageModel } from '../../models/organization-background-image-model';

export interface AdminFhirIdBackgroundImagesGet$Params {
  fhirId: string;
}

export function adminFhirIdBackgroundImagesGet(http: HttpClient, rootUrl: string, params: AdminFhirIdBackgroundImagesGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OrganizationBackgroundImageModel>>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdBackgroundImagesGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<OrganizationBackgroundImageModel>>;
    })
  );
}

adminFhirIdBackgroundImagesGet.PATH = '/Admin/{fhirId}/BackgroundImages';
